export class MaximizeViewerListener {
    public static bindDocumentClickCapture(handler: (event: MouseEvent) => void): void {
        document.addEventListener("click", handler, true);
    }

    public static bindClose(closeBtn: HTMLElement | null, onClose: () => void): void {
        if (!(closeBtn instanceof HTMLElement)) return;
        closeBtn.addEventListener("click", () => onClose());
    }

    public static bindBackdrop(backdrop: HTMLElement | null, onClose: () => void): void {
        if (!(backdrop instanceof HTMLElement)) return;
        backdrop.addEventListener("click", () => onClose());
    }

    public static bindModalBody(body: HTMLElement | null, onClose: () => void): void {
        if (!(body instanceof HTMLElement)) return;
        body.addEventListener("click", (e) => {
            if (e.target === body) onClose();
        });
    }

    public static bindEscapeKey(modal: HTMLElement, onClose: () => void): void {
        document.addEventListener("keydown", (e) => {
            if (e.key === "Escape" && !modal.hidden) {
                onClose();
            }
        });
    }
}
